export { initLightGallery };

import lightGallery from "lightgallery";
// Plugins
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgVideo from 'lightgallery/plugins/video'

const initLightGallery = () => {
  jQuery(document).ready(function ($) {
    let lightgalleries = document.getElementsByClassName("lightgallery");
 
    for (let lightgallery of lightgalleries) {
      const dynamicElements = [];
    
      // Collectez les informations pour chaque diapositive dynamique
      const galleryItems = lightgallery.querySelectorAll('.gallery, .block-video');
      galleryItems.forEach(item => {
        let href = '';
        const thumb = item.querySelector('img').getAttribute('src');
        // console.log(item.classList());
        if(item.classList.contains('block-video')){
          href = item.getAttribute('src');
          dynamicElements.push({
            src: href,
            thumb: thumb,
          });
        }else{
          href = item.getAttribute('href');
          dynamicElements.push({
            src: href,
            thumb: thumb,
          }); 
        }
      });
    
      // Initialisez LightGallery avec les éléments dynamiques
      let dynamicGallery = lightGallery(lightgallery, {
        plugins: [lgThumbnail, lgVideo],
        thumbnail: true,
        licenseKey: "E62D8D2A-BD034E17-905EF25C-72A9C3B6",
        download: false,
        share: false,
        speed: 500,
        dynamic: true,
        dynamicEl: dynamicElements,
      });

      galleryItems.forEach((value, key) => {
        value.addEventListener('click', function (event) {
          event.preventDefault()
          dynamicGallery.openGallery(key)
        }) 
      })
    
    }
  

    let lightgalleryLabels = document.getElementsByClassName("lightgallery-labels");
 
    for (let lightgallerylabel of lightgalleryLabels) {
      lightGallery(lightgallerylabel, {
        plugins: [lgThumbnail, lgVideo],
        thumbnail: true,
        licenseKey: "E62D8D2A-BD034E17-905EF25C-72A9C3B6",
        download: false,
        share: false,
        speed: 500,
        addClass : 'lightgallery-labels-custom'
      });

    }
  });
};
 